import {useTranslation} from 'react-i18next';
import SettingItem from '../settingItem/SettingItem';
import {useSelector} from 'react-redux';
import {getAccountClubPermissions} from '../../../redux/account/accountActions';
import {useEffect, useState} from 'react';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {createClubSettingInputs} from './createClubSettingInputs';

function ClubForm() {
    const {t} = useTranslation('permission');
    const consumerClubs = useSelector(state => state.account.consumerClubs);
    const getAccountClubPermissionsXHR = useSelector(state => state.account.getAccountClubPermissionsXHR);
    const tickets = useSelector(state => state.tickets.tickets);
    const eventId = useSelector(state => state.event.eid);
    const couponTicketClubs = useSelector(state => state.event.settings?.clubs?.couponTicketClubs) || [];
    const [selectedTickets, setSelectedTickets] = useState({});
    
    const initialTicketTokens = couponTicketClubs.reduce((acc, coupon) => {
        if(coupon.clubId && coupon.tid && coupon.ticketToken) {
            if(!acc[coupon.clubId]) {
                acc[coupon.clubId] = {};
            }
            acc[coupon.clubId][coupon.tid] = coupon.ticketToken;
        }
        return acc;
    }, {});
    
    useEffect(() => {
        if(getAccountClubPermissionsXHR !== 'SUCCESS') {
            getAccountClubPermissions().then();
        }
    }, []);

    const ticketsList = tickets?.map(ticket => {
        const couponTicketData = couponTicketClubs.find(coupon => coupon.tid === ticket.tid);
        return {
            text: ticket.title,
            key: ticket.tid,
            ...(couponTicketData && {ticketToken: couponTicketData.ticketToken, cid: couponTicketData.cid, clubId: couponTicketData.clubId})
        };
    }).filter(ticket => ticket.text) || [];

    const getTicketsForClub = (clubId) => {
        const availableTickets = ticketsList.filter(ticket => {
            const isSelectedForThisClub = selectedTickets[clubId]?.key === ticket.key;
            const hasTokenForThisClub = ticket.clubId === clubId && ticket.ticketToken;
            return !hasTokenForThisClub && !isSelectedForThisClub;
        });

        const ticketsWithToken = ticketsList.filter(ticket => 
            ticket.clubId === clubId && ticket.ticketToken
        );
        const selectedTicket = selectedTickets[clubId];
        if(selectedTicket) {
            ticketsWithToken.push(selectedTicket);
        }

        return {
            available: availableTickets,
            withToken: ticketsWithToken
        };
    };

    const handleTicketSelection = (clubId, selectedTicket) => {
        setSelectedTickets(prev => ({
            ...prev,
            [clubId]: selectedTicket
        }));
    };

    const clearSelectedTicket = (clubId) => {
        setSelectedTickets(prev => {
            const newState = {...prev};
            delete newState[clubId];
            return newState;
        });
    };

    const {getTicketsList, getTicketTokenInput} = createClubSettingInputs(consumerClubs || [], 'clubs', {}, t, clearSelectedTicket);

    return (
        <Formik
            initialValues={{selectedTickets: selectedTickets, ticketTokens: initialTicketTokens}}
            validationSchema={Yup.object().shape({})}
            enableReinitialize={true}
        >
            <Form>
                {consumerClubs?.map((club) => {
                    const {available, withToken} = getTicketsForClub(club.clubId);
                    
                    return (
                        <div key={club.clubId}>
                            {club.status === 1 && <SettingItem 
                                name={club.clubName} 
                                settingCategory="clubs" 
                            >
                           
                                {getTicketsList('selectedTickets', available, t('voucherForItem'), club.clubId, handleTicketSelection)}
                            
                                {withToken.map((ticketWithToken, index) => (
                                    <div key={`${club.clubId}-${ticketWithToken.key}-${index}`}>
                                        {getTicketTokenInput(`ticketTokens.${club.clubId}.${ticketWithToken.key}`, ticketWithToken, t('ticketToken'), club.clubId)}
                                    </div>
                                ))}
                            </SettingItem>}
                        </div>
                    );
                })}
            </Form>
        </Formik>
    );
}

export default ClubForm; 